module.exports = __webpack_public_path__ + "static/mid_video-e85dbef4bd764dfe44afa3c713a8e0dd.mp4";